@if (maintenanceState.blockingMaintenanceActive()) {
  @if (maintenanceScreen(); as screen) {
    <ng-container *ngComponentOutlet="screen" />
  }
} @else {
  <router-outlet />
}

@if (chunkLoading.isVisible()) {
  <div
    class="fixed inset-0 z-[10000] flex items-center justify-center bg-background/60"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <z-loader zSize="lg" />
  </div>
}
